import axios from 'axios';
import { PwWebConection } from '../types';

/**
 * Gets a list of ProjectWise connections
 *
 * @param {string} projectId Project ID to get connections for
 * @returns {Promise} List of {@link PwWebConection}
 */
export const fetchConnections = async (
  projectId: string
): Promise<PwWebConection[]> => {
  return (
    await axios.get<PwWebConection[]>(`api/project/${projectId}/connections`)
  ).data;
};

/**
 * Gets specific connection's details.
 *
 * @param {string} projectId Project ID where the connection resides
 * @param {string} connectionId Connection ID to get details
 * @returns {Promise} {@link PwWebConection} if succesful, {@link undefined} otherwise
 */
export const fetchConnectionDetails = async (
  projectId: string,
  connectionId: string
): Promise<PwWebConection | undefined> => {
  return (
    await axios.get<PwWebConection>(
      `api/project/${projectId}/connections/${connectionId}`
    )
  ).data;
};

/**
 * Create a default tab link for given connections
 *
 * @param {string} projectId Project ID to get connection
 * @param {string[]} connectionIds Connection IDs to set default tab for
 * @param {string} tabLink Link to a Teams tab
 * @returns {Promise} True if succesful, false otherwise
 */
export async function createDefaultTabForConnections(
  projectId: string,
  connectionIds: string[],
  tabLink: string
): Promise<boolean> {
  try {
    await axios.post(`api/project/${projectId}/connectionsDefaultTab`, {
      tabLink,
      connectionIds,
    });
  } catch (e) {
    console.error('Error setting default tab', e);
    return false;
  }

  return true;
}

/**
 * Delete a default tab link for given connections
 *
 * @param {string} projectId Project ID to get connection
 * @param {string[]} connectionIds Connection IDs to delete default tab for
 * @param {string} tabLink Link to a Teams tab
 * @returns {Promise} True if succesful, false otherwise
 */
export async function deleteDefaultTabForConnections(
  projectId: string,
  connectionIds: string[]
): Promise<boolean> {
  try {
    await axios.delete(`api/project/${projectId}/connectionsDefaultTab`, {
      data: { connectionIds },
    });
  } catch (e) {
    console.error('Error removing default tab', e);
    return false;
  }

  return true;
}
